<template>
  <Component
    :is="type"
    class="button"
    :class="classNames"
    @click="handleClick"
    v-bind="$attrs"
  >
    <slot></slot>
  </Component>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false
})
class Button extends Vue {
  @Prop({
    type: String,
    default: 'button',
    validator: value => ['button', 'router-link', 'a'].includes(value)
  }) type

  @Prop({
    type: String,
    default: 'contained',
    validator: value => ['contained', 'outlined'].includes(value)
  }) variant

  @Prop(Boolean) disabled
  @Prop(Boolean) waiting

  get classNames () {
    return {
      'contained': this.variant === 'contained',
      'outlined': this.variant === 'outlined',
      'disabled': this.disabled,
      'waiting': this.waiting
    }
  }

  handleClick (event) {
    if (this.disabled || this.waiting) {
      return
    }
    this.$emit('click', event)
  }
}

export default Button
</script>

<style lang="scss" src="./styles.scss" />
